module.exports = __webpack_public_path__ + "media/images/portugal_center/Tomar-89f34c18505f5615b2f94548ef75644d.jpg";